const COLLECTION_REASONS = {
  NOT_SOLD: 'not-sold-in-90-days',
  ABOVE_MAX: 'above-max-level',
  CLASSIC_TO_BASIC_TIER: 'moving-from-classic-to-basic-tier',
  DISCONTINUED: 'discontinued',
  PAYG_ONLY: 'changed-availability-to-PAYG-only'
}

module.exports = COLLECTION_REASONS
